import type { ComponentProps } from 'react';
import type { ReadonlyProp } from 'src/redux/types';

import { BlockEmptyView } from '../block-empty-view';

interface Props extends ReadonlyProp, Pick<ComponentProps<'div'>, 'onClick'> {
  defaultOpenPanel: boolean;
  text?: string;
}
export const EmptyVideo = (props: Props) => {
  return (
    <BlockEmptyView
      defaultOpenPanel={props.defaultOpenPanel}
      readonly={props.readonly}
      iconProp={{
        name: 'IcUploadVideo',
        size: 'normal',
      }}
      text={props.text ?? '添加视频'}
      onClick={props.onClick}
      className={props.readonly ? 'cursor-default' : 'cursor-pointer'}
    />
  );
};
